import { render, staticRenderFns } from "./ReferencePage.vue?vue&type=template&id=a9486310&scoped=true"
import script from "./ReferencePage.vue?vue&type=script&lang=js"
export * from "./ReferencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9486310",
  null
  
)

export default component.exports